<template>
    <div class="all-tickets-stack" :class="{ 'has-more-tickets': !isExpanded && notShownTicketsCount > 2 }">
        <div class="all-tickets-stack__wrapper">
            <div class="all-tickets-stack__header" @click="toggleOpen">
                <i class="icon icon-ticket_2 all-tickets-stack__icon"/>
                <div class="all-tickets-stack__title-and-counter">
                    <span class="all-tickets-stack__title">{{ $t('my tickets') | capitalize }}</span>
                    <span class="all-tickets-stack__ticket-counter">{{ notShownTicketsCount }}</span>
                </div>
                <i
                    class="icon all-tickets-stack__expand-state"
                    :class="{ 'icon-chevron_down': isExpanded, 'icon-chevron_up': !isExpanded }"
                ></i>
            </div>
            <div
                class="all-tickets-stack__content"
                v-if="isExpanded"
            >
                <TicketTableHeader />
                <div class="all-tickets-stack__ticket-list">
                    <StackCardItem
                        v-for="(ticket, index) in tickets"
                        :key="ticket.id"
                        :class="ticketClasses[index]"
                        v-bind="ticket"
                        @click="onTicketClick(ticket.id)"
                    />
                </div>
                <div class="ticket-stack-widget__actions">
                    <div
                        class="ticket-stack-widget__action-button"
                        @click="onShowAllClick"
                    >
                        {{ $t('Show All') }}
                    </div>
                    <div
                        v-if="isAnyTicketOpened"
                        @click="$emit('closeAll')"
                        class="ticket-stack-widget__action-button"
                    >
                        {{ $t('Close All') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { routeNames } from '@app/router/constants';
    import StackCardItem from './StackCardItem';
    import TicketTableHeader from './TicketTableHeader.vue';

    export default {
        props: {
            tickets: {
                type: Array,
                required: true,
            },
            isExpanded: {
                type: Boolean,
                required: true,
            },
            isAnyTicketOpened: {
                type: Boolean,
                required: true,
            }
        },
        computed: {
            ticketClasses() {
                const normalClass = 'ticket';
                const shownTicketClass = [normalClass, 'shown'];
                return this.tickets.map((ticket) => {
                    if (this.isOuter(ticket)) {
                        return shownTicketClass;
                    }
                    return normalClass;
                });
            },
            notShownTicketsCount() {
                return this.tickets.filter((ticket) => !this.isOuter(ticket)).length;
            },
        },
        methods: {
            toggleOpen() {
                this.$emit('toggleAll');
            },
            isOuter(ticket) {
                return ticket.isSpread || ticket.isCompressed;
            },
            onTicketClick(id) {
                this.$emit('ticketClick', id);
            },
            onShowAllClick() {
                this.$router.push({
                    name: routeNames.tickets,
                });
            },
        },
        components: {
            StackCardItem,
            TicketTableHeader,
        },
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/AllTicketsStack.vue